class BlackboxOutput extends HTMLElement {
  #shadowRoot;

  constructor() {
    super();
    this.#shadowRoot = this.attachShadow({ mode: 'closed' });
  }

  connectedCallback() {
    const template = this.querySelector('template');
    if (template) {
      const content = template.content.cloneNode(true);
      this.#shadowRoot.appendChild(content);
    }
  }
}

customElements.define('blackbox-output', BlackboxOutput);
